var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcSortDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_sort_down"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 12 0 12 12 0 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#96999C",
    fillRule: "nonzero",
    points: "5.975 3.975 5.268 4.682 4 3.414 4 10 3 10 3 3.414 1.7325 4.682 1.025 3.975 3.5 1.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#343A40",
    fillRule: "nonzero",
    points: "10.975 8.025 8.5 10.5 6.025 8.025 6.732 7.318 8.0005 8.586 8 2 9 2 9 8.586 10.268 7.318 10.975 8.025"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSortDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_sort_down.5056627c.svg";
export { ForwardRef as ReactComponent };